import React, { useContext, useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { SidebarData } from './Sidebar';
import './navbar.scss';
import logo from "../../assets/imgs/logo1.png";
import { Link } from 'react-router-dom';
import { BsFillChatDotsFill } from "react-icons/bs";
import ChatList from '../../pages/ListChat/ChatList';
import { MdLogout } from "react-icons/md"
import { Context } from '../../context/userContext';
import Swal from 'sweetalert2';

const Navbar = () => {
    const [sidebar, setSidebar] = useState(false);
    const [activeLink, setActiveLink] = useState(0); 
    const [menuOpenPosition, setMenuOpenPosition] = useState('initial'); 
    const [showMessages, setShowMessages] = useState(false);

    const { logout } = useContext(Context);

    const showSidebar = () => {
        setSidebar(!sidebar);
        setMenuOpenPosition(sidebar ? 'initial' : 'opened'); 
    };

    const closeSidebar = () => {
        setSidebar(false);
        setMenuOpenPosition('initial'); 
    };

    const toggleMessages = () => {
        setShowMessages(!showMessages);
    };

    const handleLogout = () => {
        Swal.fire({
            title: 'Êtes-vous sûr de vouloir vous déconnecter?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
        }).then((result) => {
            if (result.isConfirmed) {
                logout();
            }
        });
    };

    return (
        <div className='navbar'>
            <div className={`navbar-container`} menuopenposition={menuOpenPosition}>
                <div className='menu-open' style={{ 
                    fontSize: '23px', 
                    color: '#282881', 
                    position: 'absolute',
                    top: '15px',
                    left: menuOpenPosition === 'opened' ? 'calc(280px + 20px)' : '20px',
                    transition: 'left 0.5s ease',
                    cursor:'pointer',
                }}>
                    <FaBars onClick={showSidebar} />
                </div>
                <div onClick={toggleMessages} style={{position:'absolute', top:'9px', right:'80px', fontSize: '30px', color: '#282881', cursor:'pointer'}}>
                    <BsFillChatDotsFill />
                </div>
                <div onClick={handleLogout} style={{position:'absolute', top:'9px', right:'25px', fontSize: '30px', color: '#282881', cursor:'pointer'}}>
                    <MdLogout />
                </div>
            </div>

            <nav className={sidebar ? 'sidebar active' : 'sidebar'}>
                <div className="user-info" onClick={closeSidebar}>
                    <img src={logo} alt="logo" className='info-img'/>
                    <span className="info-name">Teny Zaraina</span>
                </div>

                <ul className='body-item' onClick={closeSidebar}>
                    {SidebarData && SidebarData.map((item, index) => (
                        <li key={index} className={index === activeLink ? 'active' : ''}>
                            <Link to={item.path} className="link" onClick={() => setActiveLink(index)}>
                                <span className="icon">{item.icon}</span>
                                <span className='title-menu'>{item.title}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>

            {showMessages && (
                <div className='messages-list'>
                    <ChatList />
                </div>
            )}
        </div>
    );
}

export default Navbar;